import classNames from 'classnames';
import styles from './ContentPage.module.scss';
import { useEffect, useRef, useState } from 'react';
import { ImageViewer } from 'antd-mobile/es/components/image-viewer/image-viewer';
import { PageTextFragment } from '@graphqlTypes/sitecore';
import { CloseCircleOutline } from 'antd-mobile-icons';

const ContentPage = ({ content, className }: { content: PageTextFragment; className: string }) => {
    const [visible, setVisible] = useState(false);
    const [currentImage, setCurrentImage] = useState<string>('');
    const contentRef = useRef<HTMLDivElement>(null);

    const handleImageClick = (url: string) => {
        setCurrentImage(url);
        setVisible(true);
    };

    useEffect(() => {
        if (contentRef.current) {
            const images = contentRef.current.querySelectorAll('img');

            images.forEach((img) => {
                const url = img.getAttribute('src');
                img.style.cursor = 'pointer';
                img.onclick = () => {
                    if (url) handleImageClick(url);
                };
            });
        }
    }, [content.contentParagraphs?.rendered]);

    return (
        <>
            {content.contentParagraphsEnabled?.boolValue && (
                <div
                    className={`mt-[1px] w-[100%] bg-[#fff] overflow-hidden ${className} ${styles.contentParagraph}`}
                >
                    <div
                        ref={contentRef}
                        className={classNames(
                            'overflow-x-auto overflow-y-auto w-[100%] break-words text-[15px]',
                            styles.contentImageRes
                        )}
                        dangerouslySetInnerHTML={{
                            __html: content.contentParagraphs?.rendered ?? '',
                        }}
                    ></div>

                    <ImageViewer
                        classNames={{
                            mask: '!flex items-center',
                        }}
                        image={currentImage}
                        visible={visible}
                        onClose={() => setVisible(false)}
                        renderFooter={() => (
                            <div className='fixed right-5 top-8' onClick={() => setVisible(false)}>
                                <CloseCircleOutline width={30} height={30} color='#FFFFFF' />
                            </div>
                        )}
                    />
                </div>
            )}
        </>
    );
};

export default ContentPage;
